module.exports = __webpack_public_path__ + "static/media/checkin_with_phone.9790f5af.jpg";